/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { animated } from '@react-spring/web';
import { CardItem } from '../card-item';
import { Filters } from './filters';
import { SearchItem } from '../../../../types/types';
import { useAnimatedSearchItems } from '../../hooks/useAnimatedSearchItems';
import { useSearchingStore } from '../../store/useSearchStore';
import { useList } from '../../hooks/useList';
import { PaginationControls } from '@/pages/bookmarks/components/PaginationControls';

export const ListSearch = () => {
  const { filters, searchPage } = useSearchingStore();
  const { items, page, pageCount, setPage, isLoading } = useList();

  const allItems: SearchItem[] = items as SearchItem[];

  const transitions = useAnimatedSearchItems(allItems || []);

  const renderItem = useCallback(
    (item: SearchItem) => (
      <CardItem
        key={(item as any)?.documentId || (item as any)?.id || (item as any)?.slug || item.__typename}
        item={item}
      />
    ),
    [],
  );

  const hasActiveSearch = Boolean(
    (filters.searchTerm && filters.searchTerm.trim().length > 0) ||
    (filters.contentTypes && filters.contentTypes.length > 0),
  );

  return (
    <div className="flex flex-col">
      <Filters />

      {hasActiveSearch && (
        <div className="mt-sh-30 space-y-8">
          <h2 className="!my-0 font-haffer text-sh-28-32 font-bold">
            {searchPage.searchPage?.yourResultsTitle || 'Results'}
          </h2>

          {allItems && allItems.length > 0 ? (
            <>
              <div className="relative">
                <div className="grid grid-cols-1 gap-6">
                  {transitions((styles, item) => (
                    <animated.div style={styles as any}>{renderItem(item as SearchItem)}</animated.div>
                  ))}
                </div>

                {isLoading && (
                  <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-white/60">
                    <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-people-teal-600" />
                  </div>
                )}
              </div>

              <PaginationControls page={page} pageCount={pageCount} onPageChange={setPage} />
            </>
          ) : isLoading ? (
            <div className="flex justify-center py-12">
              <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-people-teal-600" />
            </div>
          ) : (
            <div className="py-8 text-center">
              <p className="font-haffer text-gray-500">{searchPage.searchPage?.noRecordsFoundText || 'No Results'}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
